import { faBookMedical } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useContext, useEffect, useState } from 'react'
import { Building, Calendar2, FileText, List, ListCheck, PencilSquare, Table } from 'react-bootstrap-icons'
import Questionnaire from '../../../../../libs/api/services/Questionnaire'
import QuestionnaireBuilderContext from '../QuestionnaireBuilderProvider'
import QBuilderComponentOptions from './QBuilderComponentOptions'

export default function QBuilderComponentNew({ Component }) {
    const [sections, setSections] = useState()
    const { handleChange } = useContext(QuestionnaireBuilderContext)
    useEffect(() => {
        Questionnaire
            .ListComponentsTypes()
            .then((r) => {
                FilterAndRender(r)
            })
    }, [])


    const Icon = (type) => {
        switch (type) {
            case 'Display Text':
                return <FileText className='me-2' />
            case 'Get Input text':
                return <PencilSquare className='me-2' />
            case 'Multiple Selection':
                return <ListCheck className='me-2' />
            case 'Single Selection':
                return <List className='me-2' />
            case 'Date Picker':
                return <Calendar2 className='me-2' />
            case 'Dynamic Component Table':
                return <Table className='me-2' />
            case 'Sub Section':
                return <Calendar2 className='me-2' />
            case 'Facilities':
                return <Building className='me-2' />
            case 'ICD10':
                return <FontAwesomeIcon icon={faBookMedical} className='me-2' />
            case 'PMB':
                return <FontAwesomeIcon icon={faBookMedical} className='me-2' />
            default: <></>
        }
    }

    const FilterAndRender = (componentTypes) => {
        var _sections = [];
        for (var componentType of componentTypes) {
            if (componentType.type === 'Sub Section') continue /// These are sub components and are added elsewhere
            // const _idx = idx
            const _type = componentType.type
            var _section = _sections.find(s => s.section === componentType.category)
            if (_section) {
                //
            } else {
                _sections.push({
                    section: componentType.category,
                    components: []
                })
                _section = _sections.find(s => s.section === componentType.category)
            }
            _section.components.push(<div
                className='p-0'
                key={componentType.id}
                onClick={(e) => handleChange(Component, _type)
                    //onAction({ action: 'Set Type', type: _type, idx: _idx })

                }
            >
                {Icon(_type)}{_type}
            </div>
            )
            //_sections.push(<div><b></b></div>)
        }
        setSections(_sections)
    }



    return <div
        // style={{ cursor: 'pointer', zIndex: 999, width: 'calc(100% - 177px )', left: '177px', bottom: '0px' }}
        className='bg-light shadow rounded text-start p-2 position-fixed w-50 slide-in'>
        <div className=' '><QBuilderComponentOptions isNew={true} Component={Component} /></div>
        <div style={{ cursor: 'pointer' }} className='row m-1 text-center'>
            <b >Select the question type</b>
            {
                sections && sections.map((s) => {
                    return (<div className='col-6 text-start'>
                        <div className='text-center bg-primary-container'>
                            <b>{s.section}</b>
                        </div>
                        <div className=''>
                            {
                                s.components.map((c) => c)
                            }
                        </div>
                    </div>)
                })
            }
        </div>
    </div>
}
